import useTypedSelector from '../../../../hooks/use-typed-selector'
import {DashboardLink} from './dashboard-link'
import {NavBarLink} from './nav-bar-link'
import {InventoryLink} from './inventory-link'
import {fleetConfigSelector} from '../../../../store/state/config/selectors'
import {isInternalUserSelector} from '../../../../store/state/current-user/selectors'
import {SystemLink} from './system-link'
import {useIncidentsWidget} from '../../../../pages/dashboard-v2/components/incident-response/contexts/use-incidents-widget'
import {useFleetConfigKeyQuery} from '../../../../query/fleet-config'
import {FleetConfigKeysType} from '../../../../store/state/config/state'
import {useHasActiveVessels} from '../../../../hooks/vessels'

import type {JSX} from 'react'
import {GlobalVesselFilter} from '@/components/global-vessel-filter/global-vessel-filter'

export function NavBarContent(): JSX.Element {
    const {hasNewIncidents} = useIncidentsWidget()
    const isInternalUser = useTypedSelector(isInternalUserSelector)
    const fleetConfig = useTypedSelector(fleetConfigSelector)
    const showInventoryLink =
        fleetConfig.networkAssets ||
        fleetConfig.usbInventory ||
        fleetConfig.softwareInventory ||
        fleetConfig.nmeaInventory

    const {data: otsmConfig} = useFleetConfigKeyQuery(FleetConfigKeysType.LICENSE_OTSM)
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const isOtsmOnly = Boolean(otsmConfig?.value?.enabled)

    const hasActiveVessel = useHasActiveVessels()

    if (!isOtsmOnly || hasActiveVessel) {
        return (
            <>
                <GlobalVesselFilter variant="hamburger" />
                <DashboardLink />
                <NavBarLink id="navigation-my-vessels" path="/new-vessels" navLinkText="Vessels" />
                <NavBarLink
                    id="navigation-incidents"
                    path="/incidents"
                    navLinkText="Incidents"
                    showIndicator={hasNewIncidents}
                />
                <NavBarLink id="navigation-events" path="/events" navLinkText="Events" />
                {(isInternalUser || fleetConfig.reports) && (
                    <NavBarLink id="navigation-reports" path="/reports" navLinkText="Reports" />
                )}
                <NavBarLink id="navigation-metrics" path="/metrics" navLinkText="Metrics" />
                {(isInternalUser || showInventoryLink) && <InventoryLink />}
                <SystemLink />
            </>
        )
    }

    return (
        <>
            <NavBarLink id="navigation-ot-inventory" navLinkText="OTSM" path="/otsm" />
            {fleetConfig.reports && (
                <NavBarLink id="navigation-reports" path="/reports" navLinkText="Reports" />
            )}
            <SystemLink />
        </>
    )
}
